module.exports = __webpack_public_path__ + "img/shibai.5cd65a38.png";